"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nestIntakeQuestionIntoParent = exports.isRootQuestion = exports.groupIntakeQuestions = exports.getRootQuestion = exports.YES_ANSWER = exports.INTAKE_QUESTION_NAMES = void 0;
var _lodash = require("lodash");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var INTAKE_QUESTION_NAMES = {
  MEDICATIONS: 'Medications',
  ALLERGIES: 'Allergies',
  ALCOHOL_CONSUMPTION_FREQUENCY: 'Alcohol Consumption Frequency',
  TOBACCO_CONSUMPTION_FREQUENCY: 'Tobacco Consumption Frequency',
  TOBACCO_CONSUMPTION_DURATION: 'Tobacco Consumption Duration',
  SPECIFIC_RECREATIONAL_DRUGS: 'Specific Recreational Drugs'
};
exports.INTAKE_QUESTION_NAMES = INTAKE_QUESTION_NAMES;
var YES_ANSWER = 'Yes';
exports.YES_ANSWER = YES_ANSWER;
var getRootQuestion = function getRootQuestion(questions, currentQuestion) {
  // Questions with answers that transition to `currentQuestion`
  var previousQuestions = (0, _lodash.filter)(questions, function (q) {
    return (0, _lodash.find)(q.answers, function (a) {
      return a.transitionTo === currentQuestion.id;
    });
  });
  var isFirstQuestionInSurvey = (0, _lodash.isEmpty)(previousQuestions);
  // This usually means that `currentQuestion` can be reached through:
  // 1. a Yes answer to the previous root question
  // 2. finishing the sub-questions of the previous root question
  // > `currentQuestion` is a root question
  var hasMultiplePreviousQuestions = (0, _lodash.size)(previousQuestions) > 1;
  if (isFirstQuestionInSurvey || hasMultiplePreviousQuestions) {
    return currentQuestion;
  }
  var previousQuestion = (0, _lodash.first)(previousQuestions);

  // `previousQuestion` doesn't transition to different questions
  // depending on answer
  var previousQuestionHasNoSubQuestions = (0, _lodash.every)(previousQuestion.answers, function (a) {
    return a.transitionTo === currentQuestion.id;
  });
  if (isRootQuestion(questions, previousQuestion) && previousQuestionHasNoSubQuestions) {
    return currentQuestion;
  }
  return getRootQuestion(questions, previousQuestion);
};
exports.getRootQuestion = getRootQuestion;
var isRootQuestion = function isRootQuestion(questions, question) {
  var rootQuestion = getRootQuestion(questions, question);

  // The root question of a root question is itself
  return rootQuestion.id === question.id;
};
exports.isRootQuestion = isRootQuestion;
var isQuestionVisible = function isQuestionVisible(questions, question, formValues) {
  var _parentQuestion$patie;
  var parentQuestions = (0, _lodash.filter)(questions, function (q) {
    return (0, _lodash.find)(q.answers, function (a) {
      return a.transitionTo === question.id;
    });
  });
  if ((0, _lodash.isEmpty)(parentQuestions) || (0, _lodash.size)(parentQuestions) > 1) {
    return true;
  }
  var parentQuestion = (0, _lodash.first)(parentQuestions);
  if (!isQuestionVisible(questions, parentQuestion, formValues)) {
    return false;
  }
  if ((0, _lodash.every)(parentQuestion.answers, function (a) {
    return a.transitionTo === question.id;
  })) {
    return true;
  }

  // Depending on the step in the render cycle, formValues is not yet defined
  // Also check saved patientAnswers for values
  var parentAnswer = formValues[parentQuestion.id] || ((_parentQuestion$patie = parentQuestion.patientAnswers[0]) === null || _parentQuestion$patie === void 0 ? void 0 : _parentQuestion$patie.answerIds);
  if ((0, _lodash.isUndefined)(parentAnswer)) {
    return false;
  }
  var parentAnswers = (0, _lodash.isArray)(parentAnswer) ? parentAnswer : [parentAnswer];
  var parentAnswersObjects = parentAnswers.map(function (a) {
    return parentQuestion.answers.find(function (ans) {
      return String(ans.id) === String(a);
    });
  });
  return (0, _lodash.some)(parentAnswersObjects, function (a) {
    return a.transitionTo === question.id;
  });
};
var nestIntakeQuestionIntoParent = function nestIntakeQuestionIntoParent(questions, question, formValues) {
  var putIntoParent = function putIntoParent(parent, child) {
    if (parent.children) {
      parent.children.push(child);
    } else {
      parent.children = [child];
    }
  };
  var parentQuestion = getRootQuestion(questions, question);
  var parentQuestionAnswer = (0, _lodash.isEmpty)(parentQuestion.patientAnswers) ? undefined : parentQuestion.patientAnswers[0];
  var parentAnswer = formValues[parentQuestion.id] || (parentQuestionAnswer === null || parentQuestionAnswer === void 0 ? void 0 : parentQuestionAnswer.answerIds);
  if ((0, _lodash.isUndefined)(parentAnswer)) {
    return;
  }
  if (isQuestionVisible(questions, question, formValues)) {
    putIntoParent(parentQuestion, question);
    return;
  }
};
exports.nestIntakeQuestionIntoParent = nestIntakeQuestionIntoParent;
var composeFormValues = function composeFormValues(questions, patientAnswers) {
  return questions.reduce(function (acc, question) {
    var questionPatientAnswer = patientAnswers === null || patientAnswers === void 0 ? void 0 : patientAnswers.find(function (ans) {
      return ans.questionId === question.id;
    });
    var answer = questionPatientAnswer === null || questionPatientAnswer === void 0 ? void 0 : questionPatientAnswer.answerIds;
    acc[question.id] = answer ? answer[0] : undefined;
    return acc;
  }, {});
};
var groupIntakeQuestions = function groupIntakeQuestions(questions, patientAnswers) {
  var orderedQuestions = (0, _lodash.orderBy)((0, _lodash.cloneDeep)(questions), 'order');
  var _partition = (0, _lodash.partition)(orderedQuestions, function (q) {
      return isRootQuestion(orderedQuestions, q);
    }),
    _partition2 = _slicedToArray(_partition, 2),
    rootQuestions = _partition2[0],
    questionsToNest = _partition2[1];
  (0, _lodash.forEach)(questionsToNest, function (q) {
    return nestIntakeQuestionIntoParent(orderedQuestions, q, composeFormValues(questions, patientAnswers));
  });
  return rootQuestions;
};
exports.groupIntakeQuestions = groupIntakeQuestions;